import * as d3 from 'd3';
/** used with d3.extent to safely create a domain value */
export function sanitiseDomain(domain) {
    var min = domain[0], max = domain[1];
    if (min === undefined || max === undefined) {
        throw Error('domain is undefined');
    }
    return [min, max];
}
export var xAccessor = function (d) { return d.x; };
export var yAccessor = function (d) { return d.y; };
export function multiYExtent(lines) {
    var domain = lines.reduce(function (collection, line) {
        var yDomain = sanitiseDomain(d3.extent(line.xy.map(yAccessor)));
        collection.push.apply(collection, yDomain);
        return collection;
    }, []);
    return sanitiseDomain(d3.extent(domain));
}
export function createLineBuilder(source, xDomain, width, height) {
    var yDomain = multiYExtent(source);
    var xScale = d3.scaleTime().domain(xDomain).range([0, width]);
    var yScale = d3.scaleLinear().domain(yDomain).range([height, 0]).nice();
    var xScaledAccessor = function (d) { var _a; return (_a = xScale(xAccessor(d))) !== null && _a !== void 0 ? _a : 0; };
    var yScaledAccessor = function (d) { var _a; return (_a = yScale(yAccessor(d))) !== null && _a !== void 0 ? _a : 0; };
    return {
        data: source,
        xDomain: xDomain,
        yDomain: yDomain,
        xScale: xScale,
        yScale: yScale,
        xScaledAccessor: xScaledAccessor,
        yScaledAccessor: yScaledAccessor,
        lineGenerator: d3.line().x(xScaledAccessor).y(yScaledAccessor)
    };
}
//# sourceMappingURL=createLineBuilder.js.map